module.exports = __webpack_public_path__ + "static/preddy-ab0d9063da736ca974f8a43b14da83b1.png";